import { signal } from '@preact/signals-react'

export const groupSignal = signal(null)
export const groupLoadedSignal = signal(false)
export const groupErrorSignal = signal(false)

export const groupListSignal = signal([])
export const groupListLoadedSignal = signal(false)
export const groupListErrorSignal = signal(null)
export const groupDictionarySignal = signal(null)

export const canGrantGroupListSignal = signal([])
export const canGrantGroupListLoadedSignal = signal(false)
export const canGrantGroupListErrorSignal = signal(null)

export const groupRoleBusinessEntitiesSignal = signal([])
export const groupRoleBusinessEntitiesLoadedSignal = signal(false)
export const groupRoleBusinessEntitiesErrorSignal = signal(null)

export const groupUserListSignal = signal([])
export const groupUserListLoadedSignal = signal(false)
export const groupUserListErrorSignal = signal(false)
export const groupUserDictionarySignal = signal({})

export const groupBusinessEntitiesSignal = signal([])
export const groupBusinessEntitiesLoadedSignal = signal(false)
export const groupBusinessEntitiesErrorSignal = signal(null)